import { useTranslation } from 'react-i18next';
import { getWinnerCardIndexes, useHomeTranslationsQuery } from '../../../services/HomePageServices';
import { motion } from 'framer-motion';
import { initialGoUp, whileInView, transition } from '../../../helpers/animations';

interface WinnerCardProps {
  index: number;
}

function WinnerCardsSection() {
  const homeQuery = useHomeTranslationsQuery();
  const winnersGroupTranslations = homeQuery.data ? getWinnerCardIndexes(homeQuery.data) : undefined;
  const isLoading = homeQuery.isLoading;

  function WinnerCard({ index }: WinnerCardProps) {
    const { t } = useTranslation('winners_group');
    return (
      <article className="winner_cards_container__card">
        <img
          className="winner_cards_container__image"
          src={t(`winner_cards_group_photo_link_${index}`)}
          alt={t(`winner_cards_team_name_${index}`)}
          loading="lazy"
          decoding="async"
        />
        <div className="winner_cards_container__textbox">
          <div className="winner_cards_container__section_title">{t(`winner_cards_winning_place_text_${index}`)}</div>
          <div className="winner_cards_container__title">{t(`winner_cards_team_name_${index}`)}</div>
          <div>{t(`winner_cards_team_description_${index}`)}</div>
        </div>
      </article>
    );
  }

  if (!winnersGroupTranslations || isLoading) return null;

  return (
    <motion.div
      initial={initialGoUp}
      whileInView={whileInView}
      viewport={{
        once: true,
        amount: 0.2
      }}
      transition={transition}
      className='winner_cards_container'
    >
      <div className="winner_cards_container__inner">
        <div className="winner_cards_container__grid">
          {winnersGroupTranslations.map((index) => (
            <WinnerCard key={index} index={index} />
          ))}
        </div>
      </div>
    </motion.div>
  );
}

export default WinnerCardsSection;
